import React, { ReactNode } from "react";
import { ReactComponent as AAALogo } from "assets/products/shared/icons/aaa-logo.svg";

type Step = { key: string; title: string };
type ProgressHeaderProps = {
    productName: ReactNode;
    currentStep: number;
    stepCompletion: readonly number[];
    steps: Step[];
};

const ProgressHeader = ({ productName, currentStep, stepCompletion, steps }: ProgressHeaderProps) => {
    return (
        <header className="sticky top-0 z-50 bg-base-100 border-b border-gray-200 w-full flex justify-center">
            <div className="flex items-center gap-4 tablet:gap-6 w-full max-w-content px-4 py-3 tablet:px-8 tablet:py-2">
                <div className="shrink-0">
                    <AAALogo className="h-[41px] w-[71px] tablet:h-[71px] tablet:w-[116px]" />
                </div>

                <div className="flex-1">
                    <div className="text-sm font-semibold mb-1">{productName}</div>

                    <div className="flex gap-2 w-full">
                        {steps.map((step, index) => (
                            <div key={step.key} className="w-full h-2 bg-gray-200 rounded">
                                <div
                                    className={`h-full rounded transition-[width] duration-[400ms] ease-in-out ${
                                        index <= currentStep ? "bg-secondary-content" : "bg-gray-200"
                                    }`}
                                    style={{ width: `${stepCompletion[index]}%` }}
                                    aria-label={`Step ${index + 1}: ${step.title}`}
                                    role="progressbar"
                                    aria-valuenow={stepCompletion[index]}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="flex justify-between text-xs font-semibold text-gray-400 mt-[6px]">
                        <div className="text-gray-900 font-bold text-xs">{steps[currentStep]?.title}</div>
                        <div className="text-gray-400 text-xs font-normal">{`${currentStep + 1} of ${steps.length}`}</div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default ProgressHeader;
